import { ChangeEvent, ElementType, Ref } from 'react';

import { InputBaseComponentProps } from '@mui/material';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

import { CissTextField, CissTextFieldProps } from 'components/fields/CissTextField';
import { CnpjFormatAdapter } from 'components/fields/CnpjFormatAdapter';

const formats = {
    cep: '#####-###',
    phone: '(##) #####-####',
    cpf: '###.###.###-##',
    card: '#### #### #### ####',
} as const;

type CissMaskField = CissTextFieldProps & {
    format: keyof typeof formats | 'cnpj';
};

type PatternFormatAdapterProps = PatternFormatProps<CissTextFieldProps> & {
    ref?: Ref<unknown>;
};

const PatternFormatAdapter = ({ onChange, ref, ...other }: PatternFormatAdapterProps) => {
    return (
        <PatternFormat
            {...other}
            mask="_"
            getInputRef={ref}
            onValueChange={(values) => {
                if (onChange) {
                    onChange({
                        target: {
                            value: values.value,
                        },
                    } as unknown as ChangeEvent<HTMLInputElement>);
                }
            }}
        />
    );
};

export function CissMaskField({ format, ...props }: CissMaskField) {
    const isCnpj = format === 'cnpj';

    return (
        <CissTextField
            {...props}
            slotProps={{
                input: {
                    inputComponent: (isCnpj ? CnpjFormatAdapter : PatternFormatAdapter) as ElementType<InputBaseComponentProps>,
                    inputProps: isCnpj ? {} : { format: formats[format] },
                },
            }}
        />
    );
}
